export default __webpack_public_path__ + "be58ffe8d5f60dbfd8f0f9d7db0334ed.svg";